import { environment } from '../../../environments/environment';

// Configuración de Google Analytics por ambiente
export const analyticsConfig = {
  measurementId: environment.analytics.measurementId,
  enabled: environment.analytics.enabled,
  debug: environment.analytics.debug,
  environmentName: environment.environmentName,
  productionFlag: environment.production,
  // Configuraciones adicionales
  config: {
    enhanced_measurement: true,
    session_timeout: 1800, // 30 minutos
    scroll_events: true,
    outbound_links: true,
    file_downloads: true,
    site_search: false,
    debug_mode: environment.analytics.debug,
    send_page_view: true
  }
};